import { j as i } from "../../../../_virtual/jsx-runtime.js";
import { COMMON_COLORS as n } from "../../../../constants/colors.js";
import { ResponsiveContainer as M } from "../../../../node_modules/recharts/es6/component/ResponsiveContainer.js";
import { BarChart as O } from "../../../../node_modules/recharts/es6/chart/BarChart.js";
import { XAxis as R } from "../../../../node_modules/recharts/es6/cartesian/XAxis.js";
import { YAxis as v } from "../../../../node_modules/recharts/es6/cartesian/YAxis.js";
import { Bar as D } from "../../../../node_modules/recharts/es6/cartesian/Bar.js";
const S = { top: 40, right: 30, bottom: 20, left: 5 }, P = ({
  data: e,
  height: l = 300,
  margin: x = S,
  domainY: a = [0, 40],
  barSize: m = 30,
  tickXFontSize: d = 12,
  tickXColor: f = n.greyMid,
  xAxisDy: h = 10,
  lineStrokeWidth: c = 2,
  barLabelFontSize: j = 14,
  barLabelFontWeight: y = 500,
  barLabelFill: g = n.greyDark,
  lineOffsetStart: p = 10,
  lineOffsetEnd: u = 45,
  children: k
}) => /* @__PURE__ */ i.jsx("div", { style: { height: l }, children: /* @__PURE__ */ i.jsx(M, { children: /* @__PURE__ */ i.jsxs(O, { data: e, margin: x, children: [
  /* @__PURE__ */ i.jsx(
    R,
    {
      dataKey: "range",
      axisLine: !1,
      tickLine: !1,
      tick: { fontSize: d, fill: f },
      dy: h
    }
  ),
  /* @__PURE__ */ i.jsx(v, { hide: !0, domain: a }),
  /* @__PURE__ */ i.jsx(
    D,
    {
      dataKey: "percentage",
      radius: [4, 4, 4, 4],
      barSize: m,
      label: (t) => {
        var o, s;
        const { x: r, y: A, value: C, fill: L } = t;
        return /* @__PURE__ */ i.jsxs("g", { children: [
          /* @__PURE__ */ i.jsx(
            "text",
            {
              x: r + 20,
              y: A - 20,
              fill: g,
              textAnchor: "middle",
              fontSize: j,
              fontWeight: y,
              children: `${C}%`
            }
          ),
          /* @__PURE__ */ i.jsx(
            "line",
            {
              x1: r - p,
              y1: (o = e[t.index]) == null ? void 0 : o.lineYPosition,
              x2: r + u,
              y2: (s = e[t.index]) == null ? void 0 : s.lineYPosition,
              stroke: L,
              strokeWidth: c,
              strokeDasharray: "3 3"
            }
          )
        ] });
      }
    }
  ),
  k
] }) }) });
export {
  P as default
};
